import { z } from 'zod';

export const AppStoreReviewConfigSchema = z
	.object({
		loginDaysFormat: z.string(),
		loginsCheckPeriodMinutes: z.number(),
		numberLogins: z.number(),
		showDialogNotOftenThanMins: z.number(),
		timerValueSec: z.number(),
		userRegisteredNotEarlierThanMonthsAgo: z.number()
	})
	.default({
		loginDaysFormat: 'MM/DD/YYYY',
		loginsCheckPeriodMinutes: 14400,
		numberLogins: 3,
		showDialogNotOftenThanMins: 525600,
		timerValueSec: 600,
		userRegisteredNotEarlierThanMonthsAgo: 1
	});
